<template>

    <div class="row mt-1 mx-0">
    <!-- Filtros (80%) -->
    <b-card class="col-md-9 col-sm-12">
      <!-- Switch para modalidad -->
      <b-row class="mb-1">
        <b-col md="12">
          <b-form-checkbox
            v-model="filtersTemp.modalidad"
            :value="modalidadOpts.find(opt => opt.text === 'IESS').value"
            :unchecked-value="modalidadOpts.find(opt => opt.text === 'No IESS').value"
            switch 
            size="md"
            class="ml-2"
          >
            {{ filtersTemp.modalidad === modalidadOpts.find(opt => opt.text === 'IESS').value ? 'IESS' : 'No IESS' }}
          </b-form-checkbox>
        </b-col>
      </b-row>

      <!-- Filtros principales -->
      <b-row align-v="center">
        <b-col md="6" sm="12">
          <b-form-input 
            v-model="filtersTemp.search"
            placeholder="Buscar por cédula, nombre, apellido, paciente o doctor"
            type="text" 
            class="form-control"
          />
        </b-col>
        <b-col md="3" sm="6">
          <v-select 
            id="estado" 
            v-model="filtersTemp.estadoLaboratorio" 
            :options="estadoLab400Opts"
            :reduce="option => option.value" 
            label="text" 
            placeholder="Estado"
          />
        </b-col>
        <b-col md="3" sm="6" v-if="filtersTemp.modalidad === modalidadOpts.find(opt => opt.text === 'No IESS').value">
          <v-select 
            id="cobertura" 
            v-model="filtersTemp.cobertura" 
            :options="coberturaOpts"
            :reduce="option => option.value" 
            label="text" 
            placeholder="Cobertura"
          />
        </b-col>
      </b-row>

      <!-- Filtro de especialidad -->
      <b-row class="mt-2">
        <b-col :md="isXima ? 6 : 12">
          <v-select 
            id="especialidad" 
            v-model="filtersTemp.especialidad" 
            :options="especialidadOpts"
            :reduce="option => option.value" 
            label="text" 
            placeholder="Especialidad"
          />
        </b-col>

        <b-col v-if="isXima" md="6">
          <v-select
            id="establecimiento"
            v-model="filtersTemp.establecimiento"
            :options="establecimientos"
            :reduce="option => option.value"
            label="text"
            placeholder="Establecimiento"
          />
        </b-col>
      </b-row>

      <!-- Filtros de fecha -->
      <b-row class="mt-2">
        <b-col md="12">
          <b-row align-v="center">
            <b-col md="4" sm="12">
              <v-select 
                id="tfecha" 
                v-model="filtersTemp.tipoFecha" 
                :options="fechaOpts"
                :reduce="option => option.value" 
                label="text" 
                placeholder="Tipo Fecha"
              />
            </b-col>
            <b-col md="4" sm="6" v-if="filtersTemp.tipoFecha">
              <flat-pickr 
                v-model="filtersTemp.fechaDesde" 
                placeholder="Desde" 
                class="form-control"
                :config="configdateTimePicker" 
              />
            </b-col>
            <b-col md="4" sm="6" v-if="filtersTemp.tipoFecha">
              <flat-pickr 
                v-model="filtersTemp.fechaHasta" 
                placeholder="Hasta" 
                class="form-control"
                :config="configdateTimePicker"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- Botones -->
      <b-row class="mt-2">
        <b-col md="12" class="d-flex justify-content-start">
          <b-button 
            variant="primary" 
            @click="onSetFilters"
            class="mr-1"
          >
            <font-awesome-icon icon="magnifying-glass" />
            Buscar
          </b-button>
          <b-button 
            variant="warning" 
            @click="onClearFilters"
            title="Limpiar filtros"
          >
            <i class="fa-solid fa-eraser"/>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <!-- Observaciones (20%) -->
    <b-card class="col-md-3 col-sm-12" style="border: 1px solid #c9c9c9">
      <h5>Observaciones</h5>
      <div class="d-flex align-items-center">
        <h4 class="mb-0">Sin MSP:</h4>
        <span class="ml-1"> {{ observaciones.sinMsp }} (total)</span>
        <b-form-checkbox
          v-model="filtersTemp.observaciones"
          :value="'sinMsp'"
          switch 
          size="md"
          class="ml-2"
        />
      </div>
    </b-card>
  </div>

</template>

<script>
import { getEstablecimientoLS, comprobarRoles, getIdDoctorLS } from '@/shared/helpers';
import rutas from '@/assets/utils/rutas.json';
import axios from 'axios';
import vSelect from 'vue-select';
import { especialidadService } from '@/shared/services';
import flatPickr from "vue-flatpickr-component";
import { ROLES } from '@/shared/constants';

export default {
  name: "FilterExamenes",


  components: {
    vSelect,
    flatPickr
  },


  created(){
    this.loadDataInit();
    this.loadFiltersLS();
    this.getObservaciones();
  },
  data(){
    return{
      currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),
      filtersTemp:{
        search            : null,
        especialidad      : null,
        cobertura         : null,
        estadoLaboratorio : null,
        modalidad         : '2', // Valor por defecto para modalidad
        tipoFecha         : '1', // Valor por defecto para tipoFecha
        fechaDesde        : null,
        fechaHasta        : null,
        doctor            : null,
        observaciones     : null,
        establecimiento   : null
      },
      filters: null,
      coberturaOpts: [
        { value: '2', text: 'ISSPOL' },
        { value: '3', text: 'ISSFA' },
        { value: '5', text: 'PARTICULAR' }, 
        { value: '6', text: 'PRIVADO' },  
        
      ],
      modalidadOpts : [],
      especialidadOpts : [],
      observaciones:{
        sinMsp: 0
      },

      estadoLab400Opts:[
        { value: '1',  text: 'Creado' },
        { value: '2',  text: 'Programado' },
        { value: '3',  text: 'Vinculado' },
        { value: '4',  text: 'Validado' },
      ],

      fechaOpts : [
        { text : "programada", value : "1" }, 
        { text : "atencion",     value : "2" }
      ],

      configdateTimePicker: {
        dateFormat: 'd/m/Y',
      },
      establecimientos: [],
    }
  },

  methods:{
    async loadDataInit(){
      // Cargar opciones de modalidad
      this.modalidadOpts = await this.getModalidadOpts();
      // Asegurar que filtersTemp.modalidad sea el valor de No IESS
      const noIessOption = this.modalidadOpts.find(opt => opt.text === 'No IESS');
      if (noIessOption && this.filtersTemp.modalidad !== noIessOption.value) {
        this.filtersTemp.modalidad = noIessOption.value;
      }

      // Otros filtros
      this.filtersTemp.tipoFecha = '1';
      this.especialidadOpts = await especialidadService.getOptionsSelect();
      if (this.isXima) {
        await this.fetchEstablecimientos();
      }
    },

    loadFiltersLS(){
      const dataFilters = JSON.parse(localStorage.getItem('filterLaboratorios'));
      if(dataFilters) this.filtersTemp = dataFilters;
      this.onSetFilters();
    },
    onSetFilters(){
      this.filters = { ...this.filtersTemp }
      this.$emit('apply-filters'); // Notificar al componente padre
      this.getObservaciones(); // Actualizar las observaciones con los nuevos filtros
    },


    onClearFilters(){
      this.filtersTemp = {
        search            : null,
        especialidad      : null,
        cobertura         : null,
        estadoLaboratorio : null,
        modalidad         : '2',
        tipoFecha         : '1',
        fechaDesde        : null,
        fechaHasta        : null,
        doctor            : null,
        observaciones     : false,
        establecimiento   : null
      };

      this.onSetFilters();
    },

    async getModalidadOpts() {
      const query = `
        query {
          allModalidades {
            id
            descripcion
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        if(response.status !== 200) return null;

        const response2 = response.data.data.allModalidades;

        const modalidadesMap = response2.map(item => ({
          value: item.id,
          text: item.descripcion
        }));

        return modalidadesMap;
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
        return null;
      }
    },


    async getObservaciones(){

      const query = `
        query NumeroObservacionesLaboratorio(
          $establecimiento    :ID
          $search             : String
          $fechaDesde         : String
          $fechaHasta         : String
          $cobertura          : String 
          $tipoFecha          : String 
          $modalidad           : String 
          $especialidad       : String
          $estadoLaboratorio  : String  
        ) {
          numeroObservacionesLaboratorio(
            search            : $search
            modalidad         : $modalidad
            establecimiento   : $establecimiento
            fechaDesde        : $fechaDesde
            fechaHasta        : $fechaHasta
            estadoLaboratorio : $estadoLaboratorio
            especialidad      : $especialidad
            cobertura         : $cobertura
            tipoFecha         : $tipoFecha
          ) {
            sinMsp
            status
          }
        }
      `;

      const establecimiento = getEstablecimientoLS();
      let doctor = null;
      if(this.isDoctor) doctor = getIdDoctorLS();
      const variables = {
        establecimiento   : this.filters?.establecimiento || establecimiento?.id,
        modalidad         : this.filters?.modalidad    || '2',
        search            : this.filters?.search       || '',
        estadoLaboratorio : this.filters?.estadoLaboratorio,
        cobertura         : this.filters?.cobertura,
        especialidad      : this.filters?.especialidad || '',
        fechaDesde        : this.filters?.fechaDesde   || '',
        fechaHasta        : this.filters?.fechaHasta   || '',
        tipoFecha         : this.filters?.tipoFecha     || ''
      }
      try{
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if(response.status !== 200) return;
        const response2 = response.data.data.numeroObservacionesLaboratorio;
        if(!response2) return;
        const data = {
          sinMsp: response2.sinMsp
        }
        this.observaciones = data;
      }catch(error){
        console.log('error', error)
      }
    },

    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
          value    : item.id,
          text     : item.Descripcion,
          uniCodigo: item.uniCodigo
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    }
  },

  computed: {
    isDoctor() {
      return comprobarRoles( ROLES.DOCTOR );
    },
    isXima() {
      return this.currentEstablecimiento?.uniCodigo === '36451';
    }
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        if(!this.filters) return;
        localStorage.setItem('filterLaboratorios', JSON.stringify(this.filters));
        this.$store.commit('setFilterLaboratorios', this.filters);
      }
    },
  }
}

  
</script>
